"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./style.css");
var _classnames = _interopRequireDefault(require("classnames"));
var _Password = _interopRequireDefault(require("./components/Password"));
var _Mobile = _interopRequireDefault(require("./components/Mobile"));
var _QrCode = _interopRequireDefault(require("./components/QrCode"));
var _login = require("../../../consts/login");
var _Captcha = _interopRequireDefault(require("../../Captcha"));
var _RealNameModal = _interopRequireDefault(require("../../RealNameModal"));
var _consts = require("../../../consts");
var _Portal = _interopRequireDefault(require("../../Portal"));
var _header = require("../../../consts/header");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var TAB_MAP = {
  pw: '密码登录',
  msg: '短信登录',
  qrcode: '二维码'
};
var RealNameContent = function RealNameContent() {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "\u6839\u636E\u56FD\u5BB6\u76F8\u5173\u653F\u7B56\uFF0C\u5149\u5B87\u6E38\u620F\u5C06\u9646\u7EED\u5F00\u542F\u5B9E\u540D\u8BA4\u8BC1\u5DE5\u4F5C\uFF0C\u76EE\u524D\u68C0\u6D4B\u5230\u60A8\u7684\u8D26\u53F7\u6682\u672A\u5B9E\u540D\uFF0C\u9700\u8981\u91CD\u65B0\u586B\u5199\u5B9E\u540D\u4FE1\u606F\u624D\u53EF\u7EE7\u7EED\u6E38\u620F\uFF0C\u5B9E\u540D\u4FE1\u606F\u4E0D\u4F1A\u66FF\u6362\u539F\u6709\u4E09\u9879\u8D44\u6599\u3002", /*#__PURE__*/_react.default.createElement("a", {
    href: _consts.REALNAME_DETAIL_URL
  }, "\u5B9E\u540D\u8BA4\u8BC1\u8BE6\u60C5"));
};
var Index = function Index(props) {
  var onSuccess = props.onSuccess,
    _props$mask = props.mask,
    mask = _props$mask === void 0 ? true : _props$mask,
    _props$closable = props.closable,
    closable = _props$closable === void 0 ? true : _props$closable,
    _props$useType = props.useType,
    useType = _props$useType === void 0 ? _login.DEFAULT_USE_TYPE : _props$useType;
  // 显示验证码
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    showValid = _useState2[0],
    setShowValid = _useState2[1];
  var _useState3 = (0, _react.useState)(_login.LOGIN_USE_TYPE[useType].bId),
    _useState4 = _slicedToArray(_useState3, 2),
    bId = _useState4[0],
    setBId = _useState4[1];
  // 验证码返回对象
  var _useState5 = (0, _react.useState)({}),
    _useState6 = _slicedToArray(_useState5, 2),
    validCbData = _useState6[0],
    setValidCbData = _useState6[1];
  // 是否实名
  var _useState7 = (0, _react.useState)(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isRealName = _useState8[0],
    setIsRealName = _useState8[1];
  // 刷新二维码
  var _useState9 = (0, _react.useState)(0),
    _useState10 = _slicedToArray(_useState9, 2),
    refreshCaptcha = _useState10[0],
    setRefreshCaptcha = _useState10[1];
  // 当前tab对象
  var _useState11 = (0, _react.useState)('pw'),
    _useState12 = _slicedToArray(_useState11, 2),
    curItem = _useState12[0],
    setCurItem = _useState12[1];
  // 显示补充三项
  var _useState13 = (0, _react.useState)(''),
    _useState14 = _slicedToArray(_useState13, 2),
    completeInfoUrl = _useState14[0],
    setCompleteInfoUrl = _useState14[1];
  /**
   * 显示验证码
   * @param bool
   */
  var onShow = function onShow(bool) {
    setShowValid(bool);
  };
  /**
   * 验证码提交
   * @param props
   */
  var handleCaptchaSubmit = function handleCaptchaSubmit(props) {
    // 关闭验证码
    setShowValid(false);
    setValidCbData(_objectSpread({}, props));
  };
  /**
   * 验证码取消
   */
  var handleValidClose = function handleValidClose() {
    setShowValid(false);
    setValidCbData({});
  };
  var handleChange = function handleChange(type) {
    setCurItem(type);
    if (type === 'pw') {
      setBId(_login.LOGIN_USE_TYPE[useType].bId);
    } else if (type === 'msg') {
      setBId(_login.BID_MSG);
    }
  };
  var onClose = function onClose() {
    props.onClose && props.onClose();
  };
  var onError = function onError(res) {
    if (res.error === _header.LOGIN_STATUS.IMPERFECT) {
      var _res$data = res.data,
        uuid = _res$data.uuid,
        account = _res$data.account;
      var url = '';
      if (useType === _login.DEFAULT_USE_TYPE) {
        url = "".concat(_consts.ACCOUNT_UI_URL, "/adultValidate?uuid=").concat(uuid, "&account=").concat(account);
      } else {
        url = "".concat(_consts.ACCOUNT_OVERSEAS_URL, "/account/CompleteInfo?uuid=").concat(uuid, "&account=").concat(account);
      }
      setCompleteInfoUrl(url);
    }
    props.onError && props.onError(res);
  };
  return /*#__PURE__*/_react.default.createElement(_Portal.default, {
    container: props.getContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gy_default_login_modal"
  }, mask && /*#__PURE__*/_react.default.createElement("div", {
    className: "gy_default_login_mask"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('gy_default_login_content', {
      login_container_content: props.getContainer
    })
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gy_default_login_header"
  }, closable && /*#__PURE__*/_react.default.createElement("span", {
    className: "gy_default_login_close",
    onClick: onClose
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "gy_default_login_tab"
  }, Object.keys(_login.LOGIN_USE_TYPE[useType].tab).map(function (key) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)('gy_default_login_tab_item', "gy_default_login_tab_item_".concat(key), {
        cur: key === curItem
      }),
      id: "gy_default_login_tab_item_".concat(key),
      key: key,
      onClick: function onClick() {
        return handleChange(key);
      }
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: key
    }, _login.LOGIN_USE_TYPE[useType].tab[key]));
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "gy_default_login_body"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('gy_default_login_body_item', {
      cur_item: curItem === 'pw'
    })
  }, /*#__PURE__*/_react.default.createElement(_Password.default, {
    onShow: onShow,
    validCbData: validCbData,
    onOk: onSuccess,
    onError: onError,
    setIsRealName: setIsRealName,
    setRefreshCaptcha: setRefreshCaptcha,
    curItem: curItem,
    useType: useType
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('gy_default_login_body_item', {
      cur_item: curItem === 'msg'
    })
  }, /*#__PURE__*/_react.default.createElement(_Mobile.default, {
    onShow: onShow,
    onOk: onSuccess,
    onError: onError,
    setIsRealName: setIsRealName,
    curItem: curItem
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('gy_default_login_body_item', {
      cur_item: curItem === 'qrcode'
    })
  }, /*#__PURE__*/_react.default.createElement(_QrCode.default, {
    setIsRealName: setIsRealName,
    onOk: onSuccess,
    curItem: curItem,
    onError: onError,
    bizType: _login.LOGIN_USE_TYPE[useType].bizType,
    useType: useType
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('gy_default_login_footer')
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: _login.LOGIN_USE_TYPE[useType].registerUrl,
    id: "gy_login_footer_register"
  }, "\u6CE8\u518C"), /*#__PURE__*/_react.default.createElement("a", {
    href: _login.LOGIN_USE_TYPE[useType].forgetPwdUrl,
    id: "gy_login_footer_forger_pw"
  }, "\u5FD8\u8BB0\u5BC6\u7801")))), /*#__PURE__*/_react.default.createElement(_Captcha.default, {
    onSubmit: handleCaptchaSubmit,
    bId: bId,
    onClose: handleValidClose,
    refreshCaptcha: refreshCaptcha,
    visible: showValid
  }), completeInfoUrl && /*#__PURE__*/_react.default.createElement(_RealNameModal.default, {
    content: "\u5C0A\u656C\u7684\u73A9\u5BB6\u60A8\u597D\uFF0C\u7531\u4E8E\u60A8\u8D26\u53F7\u5904\u4E8E\u5F02\u5E38\u72B6\u6001\uFF0C\u9700\u8865\u5168\u771F\u5B9E\u8EAB\u4EFD\u4FE1\u606F\u624D\u53EF\u4EE5\u7EE7\u7EED\u6E38\u620F\u3002",
    jumpUrl: completeInfoUrl
  }), isRealName && /*#__PURE__*/_react.default.createElement(_RealNameModal.default, {
    content: /*#__PURE__*/_react.default.createElement(RealNameContent, null),
    jumpUrl: _consts.REALNAME_URL
  }));
};
var _default = Index;
exports.default = _default;